import React, { useEffect } from 'react';
import Image from 'gatsby-image';
import styled from 'styled-components';

import { MenuItems } from './Nav';

import { bpMinSM } from '../utils/breakpoints';

const Wrapper = styled.div`
	font-family: var(--font-heading);

	li.nav-item:last-child {
		margin-bottom: 0;
	}

	a.nav-link {
		font-weight: bold;
	}

	a.nav-link-active {
		box-shadow: none;
		color: var(--color-primary);
	}

	${bpMinSM} {
		display: none;
	}

	.mobile-menu {
		top: 25px;
		right: 26px;
		width: 30px;
		height: 30px;
		z-index: 101;
		display: block;
		cursor: pointer;
		position: absolute;
		appearance: none;
		border-radius: 50%;
		background-color: var(--color-background);
	}

	.mobile-menu:focus {
		outline: none;
	}

	.mobile-menu-line {
		left: 50%;
		width: 20px;
		height: 3px;
		display: block;
		position: absolute;
		border-radius: 13px;
		transition-duration: 0.4s;
		transform: translateX(-50%);
		background-color: var(--color-text);
	}

	.mobile-menu-line:nth-child(1) {
		top: 9px;
	}

	.mobile-menu-line:nth-child(2) {
		bottom: 9px;
	}

	.mobile-menu.active {
		box-shadow: none;
		background-color: rgba(0, 0, 0, 0);
	}

	.mobile-menu.active .mobile-menu-line:nth-child(1) {
		transform: translate(-12px, 4px) rotate(-45deg);
	}

	.mobile-menu.active .mobile-menu-line:nth-child(2) {
		transform: translate(-12px, -5px) rotate(45deg);
	}

	.mobile-nav {
		top: 26px;
		right: 26px;
		width: 30px;
		height: 30px;
		z-index: 100;
		display: block;
		overflow: hidden;
		border-radius: 50%;
		/* position: absolute; */
		transition-duration: 0.4s;
		background-color: var(--color-background);
	}

	.mobile-nav.open {
		top: 0px;
		right: 0px;
		width: 100%;
		height: 100%;
		/* display: flex; */
		border-radius: 0;
		/* position: absolute; */
		/* align-items: center; */
		/* justify-content: center; */
		background-color: var(--color-background);
	}

	.mobile-nav-list {
		display: none;
	}

	/* .mobile-nav.open .author {
		animation-name: fadeIn;
		animation-delay: 0.1s;
		animation-duration: 1s;
		background-color: transparent;
		animation-fill-mode: forwards;
	} */

	.mobile-nav .author {
		/* opacity: 0; */
	}

	.mobile-nav-list.show {
		margin: 0;
		padding: 0;
		display: flex;
		list-style: none;
		flex-direction: column;
	}

	.mobile-nav-list li.nav-item {
		width: 100%;
		opacity: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		animation-name: fadeIn;
		animation-duration: 1s;
		background-color: transparent;
		animation-fill-mode: forwards;
	}

	.nav-item:nth-child(1) {
		animation-delay: 0.2s;
	}
	.nav-item:nth-child(2) {
		animation-delay: 0.3s;
	}

	.nav-item:nth-child(3) {
		animation-delay: 0.4s;
	}

	.nav-item:nth-child(4) {
		animation-delay: 0.5s;
	}

	.nav-item:nth-child(5) {
		animation-delay: 0.6s;
	}

	.nav-item:nth-child(6) {
		animation-delay: 0.7s;
	}

	.nav-item:not(:last-child) {
		margin-bottom: 32px;
	}

	@keyframes fadeIn {
		0% {
			opacity: 0;
			transform: translate(24px, 24px);
		}
		100% {
			opacity: 1;
		}
	}
`;

const MobileNav = ({ data, location }) => {
	useEffect(() => {
		if (typeof window != undefined) {
			const body = document.body;

			if (body.style.getPropertyValue('overflow') === 'hidden') {
				body.style.removeProperty('overflow');
			}
		}
	}, [location]);

	const toggleMenu = () => {
		const menu = document.getElementsByClassName('mobile-menu');
		const nav = document.getElementsByClassName('mobile-nav');
		const navList = document.getElementsByClassName('mobile-nav-list');
		const body = document.body;

		menu[0].classList.toggle('active');
		// nav[0].classList.toggle('fixed');
		nav[0].classList.toggle('open');
		navList[0].classList.toggle('show');

		if (menu[0].classList.contains('active')) {
			body.style.setProperty('overflow', 'hidden');
		} else {
			body.style.removeProperty('overflow');
		}
	};

	const { author } = data.site.siteMetadata;

	return (
		<Wrapper>
			<button className="mobile-menu" onClick={toggleMenu}>
				<span className="mobile-menu-line"></span>
				<span className="mobile-menu-line"></span>
			</button>
			<nav className="mobile-nav absolute flex flex-col items-center justify-center">
				<ul className="mobile-nav-list list-none m-0 px-6 py-4">
					<li className="nav-item">
						<section className="author text-center my-20">
							<Image
								alt={author.name}
								className="author-image"
								fixed={data.avatar.childImageSharp.fixed}
								style={{
									marginBottom: 0,
									minWidth: 80,
									borderRadius: `100%`,
								}}
								imgStyle={{
									borderRadius: `50%`,
								}}
							/>
							<p className="author-name text-sm py-1">
								by <strong>{author.name}</strong>
							</p>
						</section>
					</li>
					<MenuItems location={location} />
				</ul>
			</nav>
		</Wrapper>
	);
};

export default MobileNav;
